/* eslint-disable array-callback-return */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react'
import { swalMessages } from 'src/constants'
import ReportsControlPage from 'src/pages/AdminControl/ReportsAdmin/AdminControlPage'
import reportsService from 'src/services/reportsService'
import { ContextDownload } from 'src/context/ContextDownload'
import { Context } from 'src/context/Contex'
import swal from 'sweetalert'
import { loaderService } from 'src/services/loaderService'

const AdminReportsContainer = () => {
  const [reportDataStudio, setReportDataStudio] = useState([])
  const [reportsLucia, setReportsLucia] = useState([])
  const [openForm, setOpenForm] = useState(false)

  const [searchReport, setSearchReport] = useState('')
  const [inputSearch, setInputSearch] = useState('')
  const [create, setCreate] = useState({})

  const { permisos } = useContext(Context)
  const { setIdReport } = useContext(ContextDownload)

  const getReportDataStudioLucia = async () => {
    loaderService.show()
    const reportArray = await reportsService.getReportDataStudioLucia()
    const { data } = await reportsService.getReportsDataStudio()

    if (reportArray) {
      if (data) {
        let noMach = []
        const result = reportArray.map((report, index) => {
          const tmp = report.url.split('reporting/')[1]?.split('/')[0]
          const someIndex = data.findIndex((item) => item.name === tmp)
          noMach = data.filter((item) => item.name !== tmp)
          report.idIndex = index
          if (someIndex !== -1) {
            report = { ...report, ...data[someIndex], nothere: true }
          } else {
            report.nothere = false
          }
          return report
        })
        setReportsLucia(result)
        setReportDataStudio(noMach)
      } else {
        swal(swalMessages.DATA_STUDIO_ERROR)
        setReportsLucia(reportArray)
      }
    }
    loaderService.hide()
  }

  useEffect(() => {
    let active = true
    if (active) {
      getReportDataStudioLucia()
    }
    return () => {
      ;(active = false), setReportsLucia([])
    }
  }, [])

  /*= =======================================================================
  Update Data studio
======================================================================== */
  const handleUpdate = (index) => {
    reportsService
      .putReportDataStudio(reportsLucia[index])
      .then((response) => {
        if (response.data.success === 0) {
          swal(swalMessages.WARNING_DATASTUDIO)
        } else {
          swal(swalMessages.SUCCESSFUL_MESSAGE)
          // getReportDataStudio()
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  /*= =======================================================================
  Create Data studio
======================================================================== */
  const handleSubmit = async (event) => {
    event.preventDefault()
    const response = await reportsService.postReportDataStudio(create)
    if (!response) {
      swal(swalMessages.NOT_PERMITS)
    } else {
      swal(swalMessages.SUCCESSFUL_MESSAGE)
      getReportDataStudioLucia()
      setOpenForm(false)
    }
  }

  /*= =======================================================================
  Delete Data studio
======================================================================== */
  const handleDelete = (params) => {
    const updatedReports = reportsLucia.filter((report) => report.id !== params)
    swal(swalMessages.DELETE_REPORT_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const response = await reportsService.deleteReportDataStudio(params)
        if (response) {
          setReportsLucia(updatedReports)
          swal('Ok! Reporte eliminado exitosamente', {
            icon: 'success',
          })
        } else {
          swal(swalMessages.DELETE_ERROR)
        }
      }
    })
  }

  const onChangeInput = (event) => {
    setInputSearch(event.target.value.toLowerCase())
    if (event.target.value.length === 0) setReportsLucia(reportsLucia)
  }

  const onSearchReports = (event) => {
    setSearchReport(event.target.value)
  }

  const handleCreateReport = (type, event, index) => {
    setCreate({ ...create, [type]: event })
    if (typeof index === 'number') {
      setReportsLucia((prev) => [
        ...prev.slice(0, index),
        (prev[index] = {
          ...prev[index],
          [type]: event,
        }),
        ...prev.slice(index + 1),
      ])
    }
  }

  const onCreateReport = (event) => {
    event.preventDefault()
    setOpenForm(!openForm)
  }

  const handleSearchReport = async (event) => {
    loaderService.show()
    event.preventDefault()
    const { data = [] } = await reportsService.getReportByUser(searchReport)
    let someIndex = 0
    if (data.length > 0) {
      const result = reportsLucia
        .map((report) => {
          const tmp = report.url.split('reporting/')[1]?.split('/')[0]
          someIndex = data.findIndex((item) => item.name === tmp)
          if (someIndex !== -1) {
            report.isUser = true
          } else {
            report.isUser = false
          }
          return report
        })
        .sort((x, y) => (x.isUser === y.isUser ? 0 : x.isUser ? -1 : 1))

      result.map((report, index) => {
        report.idIndex = index
      })

      setReportsLucia(result)
    } else {
      getReportDataStudioLucia()
    }
    loaderService.hide()
  }

  const filterItems = (array, input) =>
    array.filter(
      (item) =>
        item.nombre.toLowerCase().includes(input.toLowerCase()) ||
        item.url.toLowerCase().includes(input.toLowerCase()) ||
        item.tipo.toLowerCase().includes(input.toLowerCase()),
    )

  const filteredItems = filterItems(reportsLucia, inputSearch)

  return (
    <>
      <ReportsControlPage
        openForm={openForm}
        permisos={permisos}
        reports={filteredItems}
        onDelete={handleDelete}
        setIdReport={setIdReport}
        handleUpdate={handleUpdate}
        handleSubmit={handleSubmit}
        onChangeInput={onChangeInput}
        onCreateReport={onCreateReport}
        onSearchReports={onSearchReports}
        reportDataStudio={reportDataStudio}
        handleSearchReport={handleSearchReport}
        handleCreateReport={handleCreateReport}
      />
    </>
  )
}

export default AdminReportsContainer
